import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import api from "@/lib/api";
import { Flame, Check, Lock } from "lucide-react";

const DOW = ["S", "M", "T", "W", "T", "F", "S"];
const MILESTONES = [
  { day: 3, reward: "Free message refill pack" },
  { day: 5, reward: "Premium outfit unlock" },
  { day: 7, reward: "Exclusive character asset" },
];

export default function StreakCalendar({ open, onClose }) {
  const [data, setData] = useState({ days: [], streak: 0, goal: 10 });
  useEffect(() => { if (open) api.get("/streak").then(({ data }) => setData(data)); }, [open]);

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="bg-surface border-white/10 rounded-3xl max-w-md" data-testid="streak-calendar">
        <DialogTitle className="font-heading text-xl font-bold flex items-center gap-2">
          <Flame className="w-5 h-5 text-brand" /> {data.streak}-Day Streak
        </DialogTitle>
        <DialogDescription className="text-muted-foreground">
          Send at least {data.goal} messages a day to keep your streak alive.
        </DialogDescription>
        <div className="grid grid-cols-7 gap-2 mt-3">
          {data.days.map((d, i) => (
            <div key={i} className="flex flex-col items-center gap-1">
              <span className="text-[10px] text-muted-foreground">{DOW[new Date(d.date).getDay()]}</span>
              <div className={`relative w-full aspect-square rounded-xl flex items-center justify-center ${d.achieved ? "bg-cyan-500/10 text-cyan-300 neon-ring" : "bg-white/5 text-muted-foreground"}`}>
                {d.achieved ? <Check className="w-4 h-4" /> : (d.count > 0 ? <span className="text-[10px]">{d.count}</span> : <Lock className="w-3 h-3 opacity-60" />)}
              </div>
            </div>
          ))}
        </div>
        <div className="mt-5 space-y-2">
          {MILESTONES.map((m) => {
            const unlocked = data.streak >= m.day;
            return (
              <div key={m.day} className={`flex items-center gap-3 p-3 rounded-xl border ${unlocked ? "border-brand/40 bg-brand/10" : "border-white/10 bg-ink"}`}>
                {unlocked ? <Check className="w-4 h-4 text-brand" /> : <Lock className="w-4 h-4 text-muted-foreground" />}
                <span className="text-sm flex-1">Day {m.day}: {m.reward}</span>
              </div>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
}
